import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'itemCompanyCatalog';

const itemCompanyCatalogService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  getActiveItemsByCompany: async (companyId, itemCode = null) => {
    if (!companyId) {
      return [];
    }

    const items = [
      { field: 'companyId', operator: 'equals', value: companyId },
      { field: 'active', operator: 'is', value: true },
      { field: 'deletedBy', operator: 'isEmpty' },
    ];

    if (itemCode) {
      items.push({ field: 'itemCode', operator: 'equals', value: itemCode });
    }

    const response = await request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data: {
        filter: { filterModel: { items, logicOperator: 'and' } },
        sorting: { sortModel: [{ field: 'id', sort: 'asc' }] },
        pagination: { paginationModel: { pageSize: 250, page: 0 } },
      },
    });

    return response?.rows ?? [];
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default itemCompanyCatalogService;
